import { findDrill, getTrainerClearQuery } from '@/helpers/trainer_presets'
import router from '@/router'

// import drillsMock from '@/store/trainer/drillsMock.json'

function getMappedPreset({ apiItem, allTags }) {
  return {
    id: apiItem.id,
    name: apiItem.name,
    description: apiItem.description,
    favorite: apiItem.favorite,
    created_at: apiItem.created_at,
    tags: apiItem.tags
      .map(itemOrId => allTags.find(i => i.id === (itemOrId.id || itemOrId)))
      .filter(i => i),
    ordering_position: apiItem.ordering_position,
    totals: apiItem.totals,
    public: apiItem.public,
    query: {
      ...(apiItem.query || {}),
      ...(apiItem.settings || {}),
    },
  }
}

function getExpectedApiPreset({ item, allTags }) {
  return {
    // id: item.id || `tmp_id_${Date.now()}`,
    id: item.id,
    name: item.name,
    description: item.description,
    favorite: item.favorite,
    created_at: item.created_at,
    tags: item.tags
      .map(itemOrId => allTags.find(i => i.id === (itemOrId.id || itemOrId)))
      .filter(i => i),
    ordering_position: item.ordering_position,
    totals: item.totals,
    public: item.public,
    settings: {
      ...(item.query || {}),
      ...(item.settings || {}),
    },
  }
}

//------

const getInitialState = () => ({
  drills_selected_drill: {
    // category_id: 'null',
    // id: null,
    // name: '',
    // description: '',
    // favorite: false,
    id: null,
    name: '',
    description: '',
    favorite: false,
    created_at: '',
    tags: null,
    ordering_position: null,
    totals: null,
    public: null,
  },
  drill_call_timestamp: null,
})
const state = getInitialState()

const getters = {
  drills_selected_drill: state => state.drills_selected_drill,
  drills_all: (state, getters) => {
    const allTags = getters.api_get_data('api_poker_drill_tags') || []
    let res = (getters.api_get_data('api_poker_drills') || []).map(i =>
      getMappedPreset({ apiItem: i, allTags }),
    )

    // let res = drillsMock.map(i => getMappedPreset({ apiItem: i, allTags }))
    // console.log(res)
    //  changed gametypes - people can have drills with old names
    const updatedGmtps = {
      HuSngGeneral: 'HuSngGeneralV2',
      MTTICM3mComplex: 'MTTComplex_ICM3m1000PTFT',
      MTTICM3mGeneral: 'MTTGeneral_ICM3m1000PTFT',
      MTTICM4mComplex: 'MTTComplex_ICM4m1000PTFT',
      MTTICM4mGeneral: 'MTTGeneral_ICM4m1000PTFT',
      MTTICM5mComplex: 'MTTComplex_ICM5m1000PTFT',
      MTTICM5mGeneral: 'MTTGeneral_ICM5m1000PTFT',
      MTTICM6mComplex: 'MTTComplex_ICM6m1000PTFT',
      MTTICM6mGeneral: 'MTTGeneral_ICM6m1000PTFT',
      MTTICM7mComplex: 'MTTComplex_ICM7m1000PTFT',
      MTTICM7mGeneral: 'MTTGeneral_ICM7m1000PTFT',
      MTTICM8mComplex: 'MTTComplex_ICM8m1000PTFT',
      MTTICM8mGeneral: 'MTTGeneral_ICM8m1000PTFT',
    }

    res = res.map(i => {
      let qq = i.query
      qq.gametype = updatedGmtps[qq.gametype] || qq.gametype
      qq.variant = qq.gmff_variant || qq.gmff_variant_mtt_chipev // renamed gmff_variant_mtt_chipev to gmff_variant
      if (
        qq.solution_type === 'custom' &&
        qq.fh_start_spot === 'custom_spot' &&
        !('history_spot' in qq)
      ) {
        // AI solutions used to not have start spot
        // and could have been created with fh_start_spot = 'custom_spot'
        // but without history_spot
        qq.fh_start_spot = 'preflop'
      }
      qq = getTrainerClearQuery(qq)
      const r = {
        ...i,
        query: qq,
      }
      return r
    })
    // console.log(res)
    return res
  },
}

const actions = {
  drills_set_drill(
    { state, commit, dispatch, getters },
    { namespace, items, reorder, method, hasMessage = true, hasExpectedResponse = false },
  ) {
    items = items.filter(i => i)
    const ids = items.map(i => i.id)
    const l_items = items.map(item => ({
      id: item.id,
      name: item.name,
      description: item.description,
      favorite: item.favorite,
      ordering_position: item.ordering_position,
      settings: item.query,
      ...(!item.public ? { tags: (item.tags || []).map(i => i.id || i) } : {}),
    }))
    // console.log(l_items)

    const drillData = getters.api_get_data('api_poker_drills') || []

    if (hasExpectedResponse) {
      // used in toggling favorite
      // debugger
      const allTags = getters.api_get_data('api_poker_drill_tags') || []
      const expectedResponses = items.map(item => ({
        status: 200,
        data: getExpectedApiPreset({ item, allTags }),
      }))
      dispatch('drills_handle_update', {
        namespace,
        responses: expectedResponses,
        errors: [],
        method,
        ids,
        items,
        hasMessage,
        reorder,
        hasDataCheck: true,
        skipTimestamp: true,
        drillData,
      })
    }

    if (method === 'POST') {
      // l_items = [...l_items, ...l_items, ...l_items]
      // l_items = [...l_items, ...l_items, ...l_items]
      // l_items = [...l_items, ...l_items, ...l_items]
      // l_items = [...l_items, ...l_items, ...l_items]
      // l_items = [...l_items, ...l_items, ...l_items]
      // l_items = [...l_items, ...l_items, ...l_items]
      // let names = ['Berthefried', 'Tatiana', 'Hildeburg', 'Bilbo', 'Frodo', 'Theodulph', 'Baggins', 'Lightfoot', 'Boulderhill']
      // names = [...names, ...names, ...names, ...names]
      // names = [...names, ...names, ...names, ...names]
      // names = [...names, ...names, ...names, ...names]
      // names = [...names, ...names, ...names, ...names]
      // names = [...names, ...names, ...names, ...names]
      // l_items = l_items.map((i, idx) => ({ ...i, name: `${names[idx]}_${idx}` }))

      dispatch('api_drill_post', {
        method: 'POST',
        items: l_items,
        hasMessage,
        namespace,
        hasDataCheck: true,
      })
    }
    if (method === 'PATCH') {
      dispatch('api_drill_patch', {
        method: 'PATCH',
        items: l_items,
        hasMessage,
        namespace,
        hasDataCheck: true,
        reorder,
        drillData,
      })
    }
    if (method === 'DELETE') {
      dispatch('api_drill_delete', {
        method: 'DELETE',
        ids,
        hasMessage,
        namespace,
        hasDataCheck: true,
      })
    }
  },
  drills_handle_drop(
    { state, commit, dispatch, getters },
    { dropItem, dropSurface, draggedRows, drills, sortOrder = 'asc' },
  ) {
    if (draggedRows.some(i => i.id === dropItem.id)) return

    const first = draggedRows[0]
    const dropItemIdx = drills.findIndex(i => i.id === dropItem.id)
    const draggedItemIdx = drills.findIndex(i => i.id === first.id)

    let afterVal = dropItemIdx < draggedItemIdx ? 1 : 0
    let beforeVal = dropItemIdx < draggedItemIdx ? 0 : -1

    if (sortOrder === 'desc') {
      afterVal = dropItemIdx < draggedItemIdx ? -1 : 0
      beforeVal = dropItemIdx < draggedItemIdx ? 0 : 1
    }

    let op = dropItem.ordering_position + (dropSurface === 'after' ? afterVal : beforeVal)
    op = op < 1 ? 1 : op > drills.length ? drills.length : op
    // console.log(op, dropItem, dropSurface)

    const items = draggedRows.map((i, idx) => ({
      ...i,
      ordering_position: op + idx,
      tags: i.tags.map(t => t.id || t),
    }))

    dispatch('drills_set_drill', {
      items,
      method: 'PATCH',
      hasMessage: false,
      reorder: true,
      hasExpectedResponse: true,
    })
  },
  drills_handle_update(
    { state, commit, dispatch, getters },
    {
      namespace,
      responses,
      errors,
      method,
      ids,
      items,
      hasMessage,
      hasDataCheck,
      reorder,
      drillData,
      callTimestamp,
      skipTimestamp,
    },
  ) {
    let statuses = responses.map(i => i?.status)
    if (statuses.some(status => status === 201 || status === 200 || status === 204)) {
      let res = drillData || getters.api_get_data('api_poker_drills') || []

      let message = ''
      const apiDrills = responses.map(i => i.data)

      let publicDrills = res.filter(i => i.public)
      let myDrills = res.filter(i => !i.public)

      if (method === 'POST') {
        myDrills = [...apiDrills, ...myDrills]
        message = 'success_drill_create'
      } else if (method === 'PATCH') {
        if (reorder) {
          const firstApiDrill = apiDrills[0]
          const draggedItemIdx = myDrills.findIndex(i => i.id === firstApiDrill.id)
          // decide about empty space above or below
          const increment = firstApiDrill.ordering_position - 1 < draggedItemIdx ? -1 : 0

          myDrills = myDrills.map(i => (apiDrills.find(ii => i.id === ii.id) ? null : i))
          const op = firstApiDrill.ordering_position + increment

          const insertIdx = op
          myDrills.splice(insertIdx, 0, apiDrills)
          myDrills = myDrills.flat()
          myDrills = myDrills.filter(i => i)
        }

        if (apiDrills[0].public) {
          publicDrills = publicDrills.map(i => {
            const patchedItem = apiDrills.find(ii => i.id === ii.id)
            const currItem = drillData.find(ii => i.id === ii.id)
            return patchedItem ? { ...patchedItem, totals: currItem.totals } : i
          })
        } else {
          myDrills = myDrills.map(i => {
            const patchedItem = apiDrills.find(ii => i.id === ii.id)
            const currItem = drillData.find(ii => i.id === ii.id)
            return patchedItem ? { ...patchedItem, totals: currItem.totals } : i
          })
        }

        if (reorder) {
          myDrills = myDrills.map((d, idx) => ({
            ...d,
            ordering_position: idx + 1,
          }))
        }

        message = 'success_drill_update'
      } else if (method === 'DELETE') {
        myDrills = myDrills.filter(i => !ids.includes(i.id))
        message = 'success_drill_delete'
      }

      if (reorder || method === 'POST' || method === 'DELETE') {
        myDrills = myDrills.map((d, idx) => ({
          ...d,
          ordering_position: idx + 1,
        }))
      }

      const allTags = getters.api_get_data('api_poker_drill_tags') || []
      myDrills = myDrills.map((d, idx) => ({
        ...d,
        tags: d.tags
          .map(itemOrId => allTags.find(i => i.id === (itemOrId.id || itemOrId)))
          .filter(i => i),
      }))
      res = [...publicDrills, ...myDrills]

      if (
        hasDataCheck &&
        JSON.stringify(res) === JSON.stringify(getters.api_get_data('api_poker_drills'))
      ) {
        return
      }

      if (skipTimestamp || state.drill_call_timestamp === callTimestamp) {
        // console.log(state.drill_call_timestamp === callTimestamp)
        commit('api_update_data', { key: 'api_poker_drills', data: res })

        if (method === 'POST' || (method === 'PATCH' && state.drills_selected_drill)) {
          const selectedDrill =
            (method === 'POST' && apiDrills[0]) ||
            res.find(i => i.id === state.drills_selected_drill?.id)
          if (selectedDrill) {
            commit('drills_set', { key: 'drills_selected_drill', value: selectedDrill })
          }
        }

        dispatch('router_reset_dialogs', {
          exeptions: ['trainer-advanced-filter-dialog'],
        })

        if (method === 'POST' && router.currentRoute.value.name === 'PracticeDrills') {
          router
            .replace({
              query: {
                ...router.currentRoute.value.query,
                ffdf_drill_type: 'my_drills',
              },
            })
            .catch(() => {})
        }

        if (hasMessage) {
          items = apiDrills.map(ii => getMappedPreset({ apiItem: ii, allTags }))
          dispatch('messages', {
            type: 'success',
            status: 'success_message',
            statusMessages: {
              _success_message: {
                i18n: `messages.${message}`,
                i18nNum: responses.length,
              },
            },
            hide: true,
          })
        }
      }
    }
    if (errors.length) {
      let message = ''
      if (method === 'POST') {
        message = 'error_drill_create'
      } else if (method === 'PATCH') {
        message = 'error_drill_update'
      } else if (method === 'DELETE') {
        message = 'error_drill_delete'
      }
      statuses = errors.map(err => err?.response?.status)
      statuses = [...new Set(statuses)]

      dispatch('messages', {
        type: 'error',
        status: 'err_message',
        statusMessages: {
          _err_message: {
            i18n: `messages.${message}`,
            i18nParams: { status: statuses.length ? statuses.join(', ') : 'unknown' },
            i18nNum: errors.length,
          },
        },
      })
    }
  },
  drills_start_drill({ state, commit, dispatch, getters }, { drill } = {}) {
    const item = drill || getters.drills_selected_drill
    commit('drills_set', { key: 'drills_selected_drill', value: item })

    const alpha = 'tra/alpha'
    dispatch('hands_stop', { configure: true })

    dispatch(`${alpha}/router_update_query`, {
      query: item.query,
      push: false,
      replace: false,
      saveLocally: false,
    })
    dispatch('poker_copy_module', {
      from_namespace: alpha,
      to_namespace: alpha,
      queryGroup: 'router-to-gmf-selektor',
    })

    router.push({
      name: 'PracticeTrainer',
      query: item.query,
    })
  },
  drills_setCheck_selected_drill(
    { state, commit, dispatch, rootGetters, getters },
    { namespace = 'tra/alpha' } = {},
  ) {
    let allDrills = getters.drills_all
    const queryTrainer = rootGetters[`${namespace}/query_trainer`]
    allDrills = allDrills.map(d => {
      const { drill } = findDrill({
        query: queryTrainer,
        drills: allDrills,
      })
      const active = drill?.id === d.id
      const r = {
        ...d,
        active,
      }
      return r
    })

    const activeDrills = allDrills.filter(i => i.active)
    const myDrills = activeDrills.filter(i => !i.public)
    let res = myDrills?.[0] || activeDrills?.[0]

    const selectedDrill = getters.drills_selected_drill
    if (!res || !selectedDrill || selectedDrill?.id !== res?.id) {
      res = {
        ...res,
        name: res?.name || '',
      }
      // console.log('drillCheck - setting new drill', res)
      commit('drills_set', { key: 'drills_selected_drill', value: res })
    }
  },
}
const mutations = {
  drills_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  drills_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
